/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridCallbackDetails, GridPaginationModel } from '@mui/x-data-grid';
import { debounce } from 'lodash';
import { Dispatch, useCallback, useReducer } from 'react';

import { GENERIC_REDUCER } from '@/constants/commons';

const initializerArg: IPaginationParams = {
  page: 0,
  sort: {
    updated_at: -1,
  },
  search: {},
  page_size: 10,
};

export interface IPaginationParams {
  page?: number;
  page_size?: number;
  sort?: any;
  search?: any;
}

interface IServerPaginationResult {
  filters: IPaginationParams;
  onPaginationModelChange: (page: GridPaginationModel, details: GridCallbackDetails) => void;
  resetFilters: () => void;
  onChangeFilter: (search: any) => void;
}

const useServerPagination = (): IServerPaginationResult => {
  const [filters, dispatch]: [IPaginationParams, Dispatch<Partial<IPaginationParams>>] = useReducer(
    GENERIC_REDUCER,
    initializerArg,
  );

  const onPaginationModelChange = useCallback((page: GridPaginationModel) => {
    dispatch({ page: page.page, page_size: page.pageSize });
  }, []);

  const onChangeFilter = useCallback(
    debounce((search) => {
      dispatch({
        search: {
          ...filters.search,
          ...search,
        },
      });
    }, 600),
    [filters],
  );

  const resetFilters = useCallback(() => dispatch(initializerArg), []);
  return {
    filters,
    onPaginationModelChange,
    resetFilters,
    onChangeFilter,
  };
};

export default useServerPagination;
